import React, { useState, useEffect } from "react";
import BarGraph from "./BarGraph";
import axios from "../../../utils/BasicAuthAPI";
import SessionError from "../../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../../components/ApiErrorComp/ApiErrorComp";
import liracrypt from "../../../components/Liracrypt/liracrypt";

const OutputTrend = (props) => {
  const [data, setData] = useState(null);
  const [config, setConfig] = useState(null);
  const [loginError, setLoginError] = useState(false);

  const fetchPerformanceData = () => {
    liracrypt

      .get("linedash/tabs/performancegraph", {
        lid: props.selectedLid,
        tgt: "perf1_tgt",
        actual: "perf1_act",
        title: "title1",
        limit: 10,
      })
      .then(({ data }) => {
        const fetchdata = data.data ? data.data : [];
        setConfig(data.config);
        setData(fetchdata);
      })
      .catch(function (error) {
        // message.error('ERROR: Unable to save!', 4);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  useEffect(() => {
    if (data === null) {
      fetchPerformanceData();
    }
  }, [data]);

  return (
    <>
      <SessionError visible={loginError} />
      <div
        style={{
          borderRadius: "10px",
          boxShadow: "inset 5px 5px 9px #171717,inset -5px -5px 9px #232323",
          // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
          overflow: "hidden",
          minHeight: "450px",
        }}
      >
        {config && data ? (
          <BarGraph
            title={config.legend.title}
            actLabel={config.legend.legendAct}
            tgtLabel={config.legend.legendTgt}
            data={data}
            barColor={"#FFE600"}
            divId={"productionReportChart"}
          />
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default OutputTrend;
